import React from "react";

export default function MainSection() {
  return (
    <section className="blog-page-area bg-lighter">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="blog-standard-content pt-120 rpt-100 pb-110 rpb-90 pr-15 rpr-0">
              <div className="blog-standard-item wow fadeInUp delay-0-2s">
                <div className="image">
                  <img
                    src={
                      require(`../../../assets/images/news/blog-standard-1.jpg`)
                        .default
                    }
                    alt="Blog Standard"
                  />
                </div>
                <div className="blog-header">
                  <ul className="post-meta-item mr-15">
                    <li>
                      <i className="far fa-user"></i>
                      <a href="#" rel="bookmark">
                        Daniele Custer
                      </a>
                    </li>
                    <li>
                      <i className="fas fa-calendar-alt"></i>
                      <a href="#">25 Jan 2022</a>
                    </li>
                  </ul>
                  <div className="social-style-one">
                    <span>Share Now</span>
                    <a href="http://facebook.com">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="http://twitter.com">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="https://google.com/">
                      <i className="fab fa-google-plus-g"></i>
                    </a>
                  </div>
                </div>
                <h3>
                  <a href="/blog/blog-details">
                    Monthly Web Development Update Complexity Over HTTPS, And
                    Push Notifications
                  </a>
                </h3>
                <p>
                  But we ipsum dolor sit amet, consectetur adipisicing elit sed
                  eiusmod tempor incididunt labore et dolore magna aliqua. Ut
                  enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor reprehenderit
                </p>
                <a href="/blog/blog-details" className="theme-btn">
                  Read More
                </a>
              </div>
              <div className="blog-standard-item wow fadeInUp delay-0-2s">
                <div className="image video-blog">
                  <img
                    src={
                      require(`../../../assets/images/news/blog-standard-2.jpg`)
                        .default
                    }
                    alt="Blog Standard"
                  />
                  <a
                    href="https://www.youtube.com/watch?v=9Y7ma241N8k"
                    className="mfp-iframe video-play"
                  >
                    <i className="fas fa-play"></i>
                  </a>
                </div>
                <div className="blog-header">
                  <ul className="post-meta-item mr-15">
                    <li>
                      <i className="far fa-user"></i>
                      <a href="#" rel="bookmark">
                        Daniele Custer
                      </a>
                    </li>
                    <li>
                      <i className="fas fa-calendar-alt"></i>
                      <a href="#">25 Jan 2022</a>
                    </li>
                  </ul>
                  <div className="social-style-one">
                    <span>Share Now</span>
                    <a href="http://facebook.com">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="http://twitter.com">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="https://google.com/">
                      <i className="fab fa-google-plus-g"></i>
                    </a>
                  </div>
                </div>
                <h3>
                  <a href="/blog/blog-details">
                    Monthly Web Development Update Complexity Over HTTPS, And
                    Push Notifications
                  </a>
                </h3>
                <p>
                  But we ipsum dolor sit amet, consectetur adipisicing elit sed
                  eiusmod tempor incididunt labore et dolore magna aliqua. Ut
                  enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor reprehenderit
                </p>
                <a href="/blog/blog-details" className="theme-btn">
                  Read More
                </a>
              </div>
              <div className="blog-standard-item quote-blog wow fadeInUp delay-0-2s">
                <h3>
                  <a href="/blog/blog-details">
                    Meet Smashing Book New Frontiers In Web For Better Enge
                    Tools Techniques.
                  </a>
                </h3>
              </div>
              <div className="blog-standard-item without-image wow fadeInUp delay-0-2s">
                <div className="blog-header">
                  <ul className="post-meta-item mr-15">
                    <li>
                      <i className="far fa-user"></i>
                      <a href="#" rel="bookmark">
                        Daniele Custer
                      </a>
                    </li>
                    <li>
                      <i className="fas fa-calendar-alt"></i>
                      <a href="#">25 Jan 2022</a>
                    </li>
                  </ul>
                  <div className="social-style-one">
                    <span>Share Now</span>
                    <a href="http://facebook.com">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="http://twitter.com">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="https://google.com/">
                      <i className="fab fa-google-plus-g"></i>
                    </a>
                  </div>
                </div>
                <h3>
                  <a href="/blog/blog-details">
                    Taking A Look At State Of Progressive Images And User
                    Perception Weathers
                  </a>
                </h3>
                <p>
                  But we ipsum dolor sit amet, consectetur adipisicing elit sed
                  eiusmod tempor incididunt labore et dolore magna aliqua. Ut
                  enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor reprehenderit
                </p>
                <a href="/blog-details" className="theme-btn">
                  Read More
                </a>
              </div>
              <div className="blog-standard-item wow fadeInUp delay-0-2s">
                <div className="image">
                  <img
                    src={
                      require(`../../../assets/images/news/blog-standard-3.jpg`)
                        .default
                    }
                    alt="Blog Standard"
                  />
                </div>
                <div className="blog-header">
                  <ul className="post-meta-item mr-15">
                    <li>
                      <i className="far fa-user"></i>
                      <a href="#" rel="bookmark">
                        Daniele Custer
                      </a>
                    </li>
                    <li>
                      <i className="fas fa-calendar-alt"></i>
                      <a href="#">25 Jan 2022</a>
                    </li>
                  </ul>
                  <div className="social-style-one">
                    <span>Share Now</span>
                    <a href="http://facebook.com">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="http://twitter.com">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="https://google.com/">
                      <i className="fab fa-google-plus-g"></i>
                    </a>
                  </div>
                </div>
                <h3>
                  <a href="/blog/blog-details">
                    Monthly Web Development Update Complexity Over HTTPS, And
                    Push Notifications
                  </a>
                </h3>
                <p>
                  But we ipsum dolor sit amet, consectetur adipisicing elit sed
                  eiusmod tempor incididunt labore et dolore magna aliqua. Ut
                  enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor reprehenderit
                </p>
                <a href="/blog/blog-details" className="theme-btn">
                  Read More
                </a>
              </div>
              <ul className="pagination flex-wrap">
                <li className="page-item disabled">
                  <span className="page-link">
                    <i className="fas fa-chevron-left"></i>
                  </span>
                </li>
                <li className="page-item active">
                  <span className="page-link">
                    01
                    <span className="sr-only">(current)</span>
                  </span>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    02
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    03
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link" href="#">
                    <i className="fas fa-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-sm-9">
            <div className="blog-sidebar mt-120 rmy-100">
              <div className="widget widget-search wow fadeInUp delay-0-2s">
                <form action="#">
                  <input
                    type="text"
                    placeholder="Search"
                    className="searchbox"
                    required
                  />
                  <button
                    type="submit"
                    className="searchbutton fa fa-search"
                  ></button>
                </form>
              </div>
              <div className="widget widget-recent-post wow fadeInUp delay-0-4s">
                <h3 className="widget-title">Recent News</h3>
                <div className="widget-news-wrap">
                  <div className="widget-news-item">
                    <img
                      src={
                        require(`../../../assets/images/news/news-widget-1.jpg`)
                          .default
                      }
                      alt="News"
                    />
                    <div className="widget-news-content">
                      <h5>
                        <a href="/blog/blog-details">
                          Quick Win For Improe Perfor Securitys.
                        </a>
                      </h5>
                      <span className="date">
                        <a href="#">15 Dec 2021</a>
                      </span>
                    </div>
                  </div>
                  <div className="widget-news-item">
                    <img
                      src={
                        require(`../../../assets/images/news/news-widget-2.jpg`)
                          .default
                      }
                      alt="News"
                    />
                    <div className="widget-news-content">
                      <h5>
                        <a href="/blog/blog-details">
                          Quick Win Imperfora Security Web ses
                        </a>
                      </h5>
                      <span className="date">
                        <a href="#">15 Dec 2021</a>
                      </span>
                    </div>
                  </div>
                  <div className="widget-news-item">
                    <img
                      src={
                        require(`../../../assets/images/news/news-widget-3.jpg`)
                          .default
                      }
                      alt="News"
                    />
                    <div className="widget-news-content">
                      <h5>
                        <a href="/blog/blog-details">
                          We’ve Got Announce ment Make Rachel
                        </a>
                      </h5>
                      <span className="date">
                        <a href="#">15 Dec 2021</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="widget widget-category wow fadeInUp delay-0-2s">
                <h3 className="widget-title">Category</h3>
                <ul className="list-style-two">
                  <li>
                    <a href="#">Business Strategy</a> <span>(20)</span>
                  </li>
                  <li>
                    <a href="#">Investment Planning</a> <span>(05)</span>
                  </li>
                  <li>
                    <a href="#">Financial Investment</a> <span>(03)</span>
                  </li>
                  <li>
                    <a href="#">Banking & Insurance</a> <span>(30)</span>
                  </li>
                  <li>
                    <a href="#">Free Consulting</a> <span>(07)</span>
                  </li>
                  <li>
                    <a href="#">Meet Our Team</a> <span>(09)</span>
                  </li>
                </ul>
              </div>
              <div className="widget widget-tag-cloud wow fadeInUp delay-0-2s">
                <h3 className="widget-title">Category</h3>
                <div className="tags">
                  <a href="#">Cleaning</a>
                  <a href="#">Business</a>
                  <a href="#">Booking</a>
                  <a href="#">car</a>
                  <a href="#">House</a>
                  <a href="#">Apartment</a>
                  <a href="#">Washing</a>
                  <a href="#">Agency</a>
                  <a href="#">Listing</a>
                </div>
              </div>
              <div className="widget widget-call-action wow fadeInUp delay-0-2s">
                <div className="call-action-widget">
                  <h2>Work Together</h2>
                  <p>
                    Bur wemust ipsum dolor sit amet consectetur adipisicing elit
                    sed eiusmod tempor incididunt ut labore
                  </p>
                  <a
                    className="theme-btn style-five btn-circle"
                    href="/contact"
                  >
                    Contact Now <i className="fas fa-angle-double-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
